import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-prev--sprite",
  "use": "arrow-prev--sprite-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-prev--sprite\">\n<path d=\"M21.6663 9.66634H5.43967L12.893 2.21301L10.9997 0.333008L0.333008 10.9997L10.9997 21.6663L12.8797 19.7863L5.43967 12.333H21.6663V9.66634Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol